import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

const { app } = window;

// [appNav]
vuwer.add("appNav", {
	className: "app-nav",
	btnHamburgerText: "メニュー",
	btnLogoutText: "ログアウト",
	
	selector() {
		const $self = $("<nav/>").addClass(this.className).attr("data-items", 0);
		const appHeader = vuwer.get("appHeader");
		if(appHeader && appHeader.$self) {
			$self.insertAfter(vuwer.get("appHeader").$self);
		} else {
			$self.appendTo(document.body);
		}
		
		return $self;
	},
	
	onReady($self) {
		if(!$self) {
			return false;
		}
		
		// [ハンバーガーボタン]
		this.$btnToggle = $("<a/>").addClass("btn-toggle").attr({
			href: "./"
		}).append( $("<span/>").text(this.btnHamburgerText) ).appendTo(this.$self);
		
		// [ログアウトボタン]
		this.$btnLogout = $("<a/>").addClass("btn-logout").attr({
			"id": "btn_logout",
			"href": "./"
		}).append( $("<span/>").text(this.btnLogoutText) ).appendTo(this.$self);
		
		// [add event listener]
		$self
		.on("click", ".btn-logout", e => {
			e.preventDefault();
			
			if(!app.config.account) {
				return false;
			}
			
			$(e.currentTarget).hasClass("is-disable") || app.logout();
		})
		.on("click", ".btn-toggle", (e, isTrigger) => {
			var $btn;
			e.preventDefault();
			
			if(!app.config.account && !isTrigger) {
				return false;
			}
			
			$btn = $(e.currentTarget).toggleClass("is-active");
			$btn.isActive = $btn.hasClass("is-active");
			
			vuwer.get("body").$self.off(".hamburger").toggleClass("is-menu-open", $btn.isActive);
			
			if($btn.isActive) {
				// bodyクリックで非アクティブにする
				setTimeout($.fn.on.bind(vuwer.get("body").$self, "click.hamburger", function(e) {
					$btn.trigger("click", [true]);
				}), 0);
			}
		})
		.on("click", ".menu a", e => {
			if(!app.config.account) {
				return false;
			}
		})
		.on("click", ".toggle-menu", e => {
			$(e.currentTarget).toggleClass("is-active").next(".sub-menu").slideToggle(200);
			return false;
		});
	}
}, function() {
	// add child Vuw
	this
	// [menu]
	.add("menu", {
		selector() {
			if(this.container.$btnToggle) {
				return $("<ul/>").addClass("menu").attr("data-vuw-template", 1)
				.insertAfter(this.container.$btnToggle);
			}
		},
		
		_currentActive: null,
		setActive(keyString) {
			( !keyString || !u_.isString(keyString) ) && (keyString = null);
			
			if(keyString !== this._currentActive) {
				!!this._currentActive && this.$self.find(".change-state.is-active").removeClass("is-active");
				if(keyString) {
					const $active = this.$self.find(`.go-${keyString}`).addClass("is-active");
					
					$active.$sub = $active.closest(".sub-menu");
					if($active.$sub.length) {
						$active.$sub.show().prev(".toggle-menu").addClass("is-active");
					}
				}
				
				this.$self.attr("data-active", keyString);
				this._currentActive = keyString;
			}
			
			return this;
		},
		
		render($elm, state) {
			if( !this.$self || !u_.isObject(state.items) ) {
				return false;
			}
			
			const keys = Object.keys(state.items);
			let count = 0;
			
			$.fn.prepend.apply( $elm, keys.map(k => {
				(k !== this.name) && count++;
				
				const $item = $("<li/>").attr("data-menu", k);
				let href = "./";
				
				if( u_.isString(state.items[k]) ) {
					(k !== app.defaultViewOfApp) && (href += k);
					const strHtml = u_.textareaParse(state.items[k]).replace(/<br\/?>/g, "");
					$("<a/>").addClass(`go-${k} change-state`).attr("href", href).append(
						$("<span/>").html( $.parseHTML(strHtml) )
					).appendTo($item);
				} else
				if(
					u_.isObject(state.items[k]) &&
					u_.isString(state.items[k].name) &&
					u_.isObject(state.items[k].items)
				) {
					$("<a/>").addClass("toggle-menu").attr("href", href).append(
						$("<span/>").html( $.parseHTML(state.items[k].name) )
					).appendTo($item);
					
					this.render(
						$("<ul/>").addClass("sub-menu").hide(),
						state.items[k]
					).appendTo($item);
				}
				
				return $item;
			}) );
			
			this.container.$self.attr("data-items", count);
			return $elm;
		}
	});
	
	app.nav = this;
});
